import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M8.7857 3.75h6.4286V2.0313c0-.5694.4777-1.0313 1.0714-1.0313.5938 0 1.0714.462 1.0714 1.0313V3.75h1.7858C20.7188 3.75 22 4.981 22 6.5v13.75c0 1.5168-1.2812 2.75-2.8571 2.75H4.8571C3.2791 23 2 21.7668 2 20.25V6.5c0-1.519 1.279-2.75 2.8571-2.75H6.643V2.0313C6.6429 1.4619 7.1205 1 7.7143 1s1.0714.462 1.0714 1.0313zM4.143 20.25c0 .3781.3196.6875.7142.6875H19.143c.3928 0 .7142-.3094.7142-.6875v-11H4.1429z" /></g>,<defs key="1"></defs>,]
, 'DisplayCalendarFilledx');
